export class YearlySnapshotDistribution {
    'year';
    'totalCount';
    'clusterCount';
    'snapshotsPerVault';
    'nonEonSnapshotCount';
    'months';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "year",
            "baseName": "year",
            "type": "number",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "clusterCount",
            "baseName": "clusterCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "snapshotsPerVault",
            "baseName": "snapshotsPerVault",
            "type": "Array<VaultSnapshotCount>",
            "format": ""
        },
        {
            "name": "nonEonSnapshotCount",
            "baseName": "nonEonSnapshotCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "months",
            "baseName": "months",
            "type": "Array<MonthlySnapshotData>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return YearlySnapshotDistribution.attributeTypeMap;
    }
    constructor() {
    }
}
